import { createFileRoute, notFound } from "@tanstack/react-router";

import { getAcademyArticle } from "@/content/academy";
import {
  CONTENT_CACHE_CONTROL,
  CONTENT_NOT_FOUND_CACHE_CONTROL,
} from "@/content/cachePolicy";
import AcademyArticlePage from "./-components/AcademyArticlePage";
import { NotFoundPage } from "@/components/landing/LandingNotFound";

export const Route = createFileRoute("/academy-article/$slug")({
  loader: async ({ params }) => {
    const article = await getAcademyArticle({ data: params.slug });
    // A real 404 rather than a 200 rendering "not found", as on the blog.
    if (!article) {
      throw notFound();
    }
    return article;
  },
  headers: ({ loaderData }) => ({
    "Cache-Control": loaderData
      ? CONTENT_CACHE_CONTROL
      : CONTENT_NOT_FOUND_CACHE_CONTROL,
  }),
  component: AcademyArticleRoute,
  notFoundComponent: NotFoundPage,
});

function AcademyArticleRoute() {
  return <AcademyArticlePage article={Route.useLoaderData()} />;
}
